export const modes = {
	STANDARD: 'standard',
	CREATE: 'create',
	DETAILED: 'detailed',
};
